var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgArrowFront = function SvgArrowFront(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14.488 25.339"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon ionic-ios-arrow-forward",
    d: "M10.121 12.665L.532 3.084a1.8 1.8 0 010-2.558 1.826 1.826 0 012.565 0l10.864 10.857a1.808 1.808 0 01.053 2.5L3.105 24.812A1.811 1.811 0 11.54 22.254z"
  })));
};
export default SvgArrowFront;